import "core-js/modules/es.string.replace-all.js";
import { mapState } from 'vuex';
import { routerJump } from '@/assets/js/utils';
export default {
  data() {
    return {
      isWeixin: navigator.userAgent.includes('MicroMessenger'),
      isAndroid: navigator.userAgent.includes('Android'),
      isIos: navigator.userAgent.includes('iPhone') || navigator.userAgent.includes('iOS'),
      needRed: !window.location.href.includes('join_id='),
      lang: navigator.language,
      isMac: false,
      isIpad: false,
      content: navigator.userAgent,
      joinPartyurl: '',
      sjUrl: require('@/assets/img/sj.png'),
      hxAndrUrl: '',
      ontouch: 'ontouchend' in document,
      env: '',
      downloadTime: null,
      isWindows: navigator.userAgent.includes('Windows'),
      Parser: require('@/assets/js/us.js'),
      logoUrl: require('@/assets/img/logoApp.png')
    };
  },
  created() {
    const parserObj = this.Parser && new this.Parser();
    String.prototype.replaceAll = function (s1, s2) {
      return this.replace(new RegExp(s1, 'gm'), s2);
    };
    // 插件为了兼容性更好
    this.isIos = parserObj && parserObj.getOS().name === 'iOS';
    this.isAndroid = parserObj && parserObj.getOS().name === 'Android';
    this.isMac = parserObj && parserObj.getOS().name === 'Mac OS';
    this.isIpad = navigator.userAgent.includes('iPad');
    this.isWindows = parserObj && parserObj.getOS().name === 'Windows';
    gtag('event', 'pageView-anywhere', {
      event_category: 'pageView',
      event_label: '移动端',
      value: 'Anywhere'
    });
    sessionStorage.setItem(this.$route.query.join_id, true);
  },
  computed: {
    ...mapState({
      Config: state => state.config,
      State: state => state
    }),
    // 根据语言浏览器版本来添加不同的URL
    downloadUrl() {
      let url = '';
      if (this.isIos || this.isIpad) {
        if (this.lang === 'zh-CN') {
          url = 'itms-apps://itunes.apple.com/cn/app/tvu-anywhere-pro/id883099579';
        } else {
          url = 'itms-apps://itunes.apple.com/us/app/tvu-anywhere-pro/id883099579';
        }
      }
      // android
      if (this.isAndroid) {
        url = 'https://play.google.com/store/apps/details?id=com.tvunetworks.android.anywhere';
      }
      // Mac
      if (this.isMac) {
        if (this.lang === 'zh-CN') {
          url = 'itms-apps://itunes.apple.com/cn/app/tvu-anywhere/id943316643';
        } else {
          url = 'itms-apps://itunes.apple.com/us/app/tvu-anywhere/id943316643';
        }
      }
      // windows
      if (this.isWindows) {
        url = 'https://www.tvunetworks.com/products/tvu-anywhere/';
      }
      return url;
    }
  },
  mounted() {
    var _this$Config;
    this.env = (_this$Config = this.Config) === null || _this$Config === void 0 ? void 0 : _this$Config.apiEnv;
    this.judgeUrl();
    document.addEventListener('visibilitychange', () => {
      // 如果页面隐藏，推测打开scheme成功，清除下载任务
      if (document.hidden || document.webkitHidden) {
        clearTimeout(this.downloadTime);
      }
    });
    window.addEventListener('pagehide', () => {
      clearTimeout(this.downloadTime);
    });
  },
  methods: {
    checkInstallApp(url) {
      window.location = url;
      if (this.isMac || this.isWindows) return; // mac下的safari
      // if (this.downloadTime) clearTimeout(this.downloadTime)
      this.downloadTime = setTimeout(() => {
        if (this.downloadUrl) {
          window.location = this.downloadUrl;
        } else {
          console.info('暂无下载地址');
        }
      }, 3000);
    },
    joinAnywhereParty() {
      this.checkInstallApp(this.joinPartyurl);
    },
    judgeUrl() {
      let url = '';
      let domain = window.location.host;
      if (domain.indexOf('.tvunetworks.com') > -1) {
        domain = 'www.tvunetworks.com';
      } else {
        domain = 'www.tvunetworks.cn';
      }
      const publicPath = this.State.publicPath || 'partyline';
      if (this.needRed) {
        const index = window.location.href.indexOf('/j/');
        if (this.isIos || this.isIpad) {
          url = `https://${domain}/${publicPath}?join_id=` + window.location.href.slice(index + 2) + `${this.env ? '&env=' + this.env : ''}`;
        }
        // mac
        if (this.isMac) {
          if (!this.ontouch) {
            url = `anywheremac://${domain}/${publicPath}?` + window.location.href.slice(index + 2) + `${this.env ? '&env=' + this.env : ''}`;
          }
        }
        // Android
        if (this.isAndroid) {
          url = window.location.origin + `/${publicPath}?' + window.location.href.slice(index + 2) + ${this.env ? '&env=' + this.env : ''}`;
          this.hxAndrUrl = `anywhere://${domain}/${publicPath}?join_id=` + window.location.href.slice(index + 2) + `${this.env ? '&env=' + this.env : ''}`;
        }

        // windows
        if (this.isWindows && !this.ontouch) {
          url = `anywherewin://${domain}/${publicPath}?` + window.location.href.slice(index + 2) + `${this.env ? '&env=' + this.env : ''}`;
        }
      } else {
        const joinIndex = window.location.href.indexOf('join_id=');
        if (this.isIos || this.isIpad) {
          url = `https://${domain}/${publicPath}?` + window.location.href.slice(joinIndex) + `${this.env ? '&env=' + this.env : ''}`;
        }
        if (this.isMac) {
          if (!this.ontouch) {
            url = `anywheremac://${domain}/${publicPath}?` + window.location.href.slice(joinIndex) + `${this.env ? '&env=' + this.env : ''}`;
          }
        }
        if (this.isAndroid) {
          url = `anywhere://${domain}/${publicPath}?` + window.location.href.slice(joinIndex) + `${this.env ? '&env=' + this.env : ''}`;
          this.hxAndrUrl = `anywhere://${domain}/${publicPath}?` + window.location.href.slice(joinIndex) + `${this.env ? '&env=' + this.env : ''}`;
        }
        // windows
        if (this.isWindows && !this.ontouch) {
          url = `anywherewin://${domain}/${publicPath}?` + window.location.href.slice(joinIndex) + `${this.env ? '&env=' + this.env : ''}`;
        }
      }
      this.joinPartyurl = url + '&' + Math.random();
    },
    joinParty() {
      const id = this.$route.query.join_id;
      const slotNum = this.$route.query.slotNum;
      const query = {
        join_id: id,
        slotNum
      };
      sessionStorage.setItem('enterPartyType', 'web');
      routerJump('preview', query);
    }
  }
};